/**
 * LineBreakType enum constant.
 */
export default {
    notSet: 0,
    newLine: 1,
    wrap: 2,
    carousel: 3
}